module.exports = __webpack_public_path__ + "static/img/logo_hikky.45b377f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_hikky.png
// module id = oIf5
// module chunks = 0